module.exports = __webpack_public_path__ + "img/zicipinyin.84f9f741.png";